export const width_9P = {
    width_i: 30,
}

export const symbol_status_9P_eng = [

]

export const symbol_status_9P_thai = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 405,
        Ypos_img: 319,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium breve`,
        Xpos_img: 405,
        Ypos_img: 401,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 405,
        Ypos_img: 481,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium longum`,
        Xpos_img: 405,
        Ypos_img: 561,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 405,
        Ypos_img: 639,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus gasseri`,
        Xpos_img: 405,
        Ypos_img: 719,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 405,
        Ypos_img: 802,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 405,
        Ypos_img: 879,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 405,
        Ypos_img: 966,
        page: 22,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]